"use client";
import { jsx } from "react/jsx-runtime";
import { tokens } from "@gnist/themes/tokens.css.js";
import reactContentLoader from "react-content-loader";
const ContentLoader = reactContentLoader;
const RectangularSkeleton = ({ className, height = "100%", width = "100%", rounded = false }) => jsx(ContentLoader, { height, width, title: "", className, backgroundColor: tokens.color.loader, foregroundColor: tokens.color["on-loader"], children: jsx("rect", { x: "0", y: "0", rx: rounded ? "4" : "0", ry: rounded ? "4" : "0", height, width }) });
export {
  RectangularSkeleton
};
